<template>
  <div>
    <v-card class="ma-2" v-if="!display">
      <v-card-text>
        <div class="text-center headline">Anda harus input data PERUSAHAAN terlebih dulu !</div>
      </v-card-text>
    </v-card>
    <div v-if="display">
      <v-form
        ref="form4"
        v-model="valid"
        lazy-validation
      >     
        <v-container>
          <v-card>
            <v-card-title class="green accent-3">Akta Pendirian
              <v-spacer />
              <v-btn @click="editClick" v-if="isEdit == false">
                <v-icon left>edit</v-icon>
                Edit
              </v-btn>
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    type="text"
                    outlined
                    label="Nomor Akta"
                    v-model="aktaANo"
                    :rules="[rules.required]"        
                    append-icon="check_circle"
                    :disabled="!isEdit" 
                  />  
                  <v-menu
                    v-model="aktaAMenu"
                    :close-on-content-click="false"
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="getDateFormattedDatefns(aktaATgl)"
                        clearable
                        label="Tanggal Akta"
                        readonly
                        v-on="on"
                        outlined
                        @click:clear="aktaATgl = null"
                        :rules="[rules.required]"  
                        :disabled="!isEdit" 
                        append-icon="check_circle"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="aktaATgl"
                      @change="aktaAMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    type="text"
                    outlined
                    label="Notaris"
                    v-model="aktaANotaris"
                    :rules="[rules.required]"        
                    append-icon="check_circle"
                    :disabled="!isEdit" 
                  />  
                  <v-file-input
                    accept=".jpg,.png,.pdf"
                    label="Dokumen Akta"
                    v-model="aktaADoc"
                    chips
                    outlined
                    :rules="[checkFileAktaAwal()]"      
                    append-icon="check_circle"  
                    :disabled="!isEdit" 
                    :placeholder="filenameAktaAwal"
                    append-outer-icon="get_app"
                    @click:append-outer="getLinkDownload(filenameAktaAwal)" 
                    clearable
                  />  
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card>
            <v-card-title dark class="green accent-3">Akta Perubahan Terakhir
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    type="text"
                    outlined
                    label="Nomor Akta"
                    v-model="aktaUNo"
                    :disabled="!isEdit" 
                  />  
                  <v-menu
                    v-model="aktaUMenu"
                    :close-on-content-click="false"
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="getDateFormattedDatefns(aktaUTgl)"
                        clearable
                        label="Tanggal Akta"
                        readonly
                        v-on="on"
                        outlined
                        @click:clear="aktaUTgl = null"
                        :disabled="!isEdit" 
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="aktaUTgl"
                      @change="aktaUMenu = false"
                    ></v-date-picker>
                  </v-menu> 
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    type="text"
                    outlined
                    label="Notaris"
                    v-model="aktaUNotaris"
                    :disabled="!isEdit" 
                  />  
                  <v-file-input
                    accept=".jpg,.png,.pdf"
                    label="Dokumen Akta"
                    v-model="aktaUDoc"
                    chips
                    outlined
                    :disabled="!isEdit"     
                    :placeholder="filenameAktaAkhir"
                    append-outer-icon="get_app"
                    @click:append-outer="getLinkDownload(filenameAktaAkhir)" 
                    @keyup.delete="aktaUDocDelete"
                    clearable
                  />  
                </v-col>
              </v-row>
              <v-divider />
              <v-row>
                <v-col cols="12">
                  <v-btn color="success" dark @click.prevent="simpan4Click" v-if="isEdit">
                    Simpan
                    <v-icon right large>arrow_right
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>
      </v-form>
    </div>          

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="loginExpired" max-width="400" persistent>
        <v-card>
            <v-card-title>Login Expired</v-card-title>
                <v-card-text>Silakan Login Ulang</v-card-text>
            <v-card-actions>
                <v-btn color="red" @click="logoutClick()">Ya</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { rules as Rules } from './../../lib/rules'
import { format, parseISO } from 'date-fns'
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  data: function() {
    return {
      valid: true,
      rules: {
        required: Rules.required,
      },
      isEdit: false,
      // data akta
      aktaId: -999,
      aktaANo: '',
      aktaATgl: null,
      aktaANotaris: '',
      aktaADoc: null,
      aktaAMenu: false,
      aktaUNo: '',
      aktaUTgl: null,
      aktaUNotaris: '',
      aktaUDoc: null,
      aktaUMenu: false,
      filenameAktaAwal: "",
      filenameAktaAkhir: "",

      submitting: false,
      loginExpired: false
    }
  },
  methods: {
    checkFileAktaAwal: function() {
      if (this.isEdit && this.filenameAktaAwal != "") return true;
      return this.aktaADoc != null || `Dokumen akta harus dilampirkan`;
    },
    /*
    checkFileAktaAkhir: function() {
      if (this.isEdit && this.filenameAktaAkhir != "") return true;
      return this.aktaUDoc != null || `Dokumen akta harus dilampirkan`;
    },
    */
    getLinkDownload: function(dok) {
      axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    getDateFormattedDatefns: function(date) {
      return date ? format(parseISO(date), "dd MMM yyyy") : ''
    },
    editClick: function() {
      this.isEdit = true
    },
    aktaUDocDelete() {  
      this.aktaUDoc = null
      this.filenameAktaAkhir = ''
    },

    simpan4Click: async function() {
      if (this.$refs.form4.validate()) { // validasi input
        // buat message
        const fdata = new FormData()
        fdata.append('aktaANo', this.aktaANo)
        fdata.append('aktaATgl', this.aktaATgl)
        fdata.append('aktaANotaris', this.aktaANotaris)
        fdata.append('aktaADoc', this.aktaADoc)
        fdata.append('aktaUNo', this.aktaUNo)
        fdata.append('aktaUTgl', this.aktaUTgl)
        fdata.append('aktaUNotaris', this.aktaUNotaris)
        fdata.append('aktaUDoc', this.aktaUDoc)
        fdata.append('vendorId', this.venId)  
        fdata.append('aktaId', this.aktaId)      
        fdata.append('filenameAktaAwal', this.filenameAktaAwal)
        fdata.append('filenameAktaAkhir', this.filenameAktaAkhir)

        // simpan ke database
        if (this.aktaId == -999) {
          this.$store.dispatch('displayProgBar')
          this.submitting = true;

          await axios.post(apiUrl + '/vendor/register3/akta', fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
          .then((response) => {
            this.$store.dispatch('displayAlert', {
              color: 'success', 
              message: `Data akta perusahaan telah tersimpan !` })
            this.$store.dispatch('ven/assignVendor', response.data.data)
            this.$store.commit('reg/setStatusAkta', 'V')
            this.aktaId = response.data.data.aktaId
            this.filenameAktaAwal = response.data.data.dokumenAwal;
            this.filenameAktaAkhir = response.data.data.dokumenUbah;

            window.scroll(0,0)
          })
          .catch((error) => {
            if(error.response.status == 401) {
              this.loginExpired = true;
            }else if(error.response.status == 422) {
              this.loginExpired = true;
            }else {
              this.$store.dispatch('displayAlert', {color: 'error', message: `Gagal update! ${error.response.data.message}`})
              window.scroll(0,0)
            }
          })
          .finally(() => {
            this.$store.dispatch('closeProgBar')
            this.submitting = false;
          })   
        }   
        else {
          this.$store.dispatch('displayProgBar')   
          this.submitting = true;

          await axios.post(apiUrl + '/vendor/register3/akta/update', fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
          .then((response) => {
            this.$store.dispatch('displayAlert', {
              color: 'success', 
              message: `Data akta perusahaan telah tersimpan !` })
            this.$store.dispatch('ven/assignVendor', response.data.data)
            this.filenameAktaAwal = response.data.data.dokumenAwal;
            this.filenameAktaAkhir = response.data.data.dokumenUbah;
            window.scroll(0,0)
          })
          .catch((error) => {
            if(error.response.status == 401) {
              this.loginExpired = true;
            }else if(error.response.status == 422) {
              this.loginExpired = true;
            }else {
              this.$store.dispatch('displayAlert', {color: 'error', message: `Gagal menyimpan! ${error.response.data.message}`})
              window.scroll(0,0)
            }
          })
          .finally(() => {
            this.$store.dispatch('closeProgBar')
            this.submitting = false;
          })   
        }          

        this.isEdit = false
      }
    },
    logoutClick: function() {
        this.$store.dispatch('logout')
        .then(() => {
            this.$router.push('/')
        })
    }
  },
  created: function() {
    this.$store.dispatch('displayPageTitle', 'Akta Perusahaan')
    axios.get(`${apiUrl}/vendor/register3/akta/${this.venId}`)
    .then((response) => {  
      if (response.data.data.aktaId !== -999) {
        this.aktaId = response.data.data.aktaId
        this.aktaANo = response.data.data.aktaANo
        this.aktaATgl = response.data.data.aktaATgl
        this.aktaANotaris = response.data.data.aktaANotaris
        this.aktaUNo = response.data.data.aktaUNo
        this.aktaUTgl = response.data.data.aktaUTgl
        this.aktaUNotaris = response.data.data.aktaUNotaris
        this.filenameAktaAwal = response.data.data.aktaADoc;
        this.filenameAktaAkhir = response.data.data.aktaUDoc;
        this.isEdit = false
      }
      else {
        this.isEdit = true
      }      
    })
  },
  computed: {
    display: function() {
      return this.$store.getters['ven/venId'] != -999
    },
    venId: function() { 
      return this.$store.getters['ven/venId']
    },    
  }
}
</script>

<style>

</style>